import { Routes } from '@angular/router';
import { provideLicenseStore } from '@app/store/license';
import { providePackageStore } from '@app/store/package';
import { ModalComponent } from '@shared/components';
import { EditComponent } from './edit/edit.component';
import { ViewComponent } from './view/view.component';
import { UpgradeComponent } from './upgrade/upgrade.component';

export const licensesModalRoutes: Routes = [
    {
        path: 'licenses/view/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideLicenseStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'licenses/edit/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideLicenseStore()],
        children: [{ path: '', component: EditComponent }],
    },
    {
        path: 'licenses/upgrade/:id',
        component: ModalComponent,
        outlet: 'modal',
        providers: [...provideLicenseStore(), ...providePackageStore()],
        children: [{ path: '', component: UpgradeComponent }],
    },
];
